/**
 * App shell — providers + router.
 *
 * Order matters: QueryClientProvider must be outermost because AuthProvider
 * uses useQuery. RouterProvider is inside AuthProvider so route guards can
 * read auth state via useAuth().
 */

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "react-router";

import "./lib/i18n"; // side-effect initialize i18n
import { queryClient } from "./lib/queryClient";
import { AuthProvider } from "./lib/auth/context";
import { router } from "./router";

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
      {import.meta.env.DEV ? (
        <ReactQueryDevtools buttonPosition="bottom-right" />
      ) : null}
    </QueryClientProvider>
  );
}
